import { render, staticRenderFns } from "./site-edit.vue?vue&type=template&id=583d657f&scoped=true&"
import script from "./site-edit.vue?vue&type=script&lang=js&"
export * from "./site-edit.vue?vue&type=script&lang=js&"
import style0 from "./site-edit.vue?vue&type=style&index=0&id=583d657f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583d657f",
  null
  
)

export default component.exports